




















import UserProfileForm from "@/components/user/UserProfileForm.vue";
import { Component, Vue } from "vue-property-decorator";
import api from "@/getinfo-api";
import { User } from "@/services/notifications";
import * as model from "@/api/models";

@Component({
  components: { UserProfileForm }
})
export default class ProfileEdit extends Vue {
  protected user!: model.User | undefined;
  protected userId!: string | undefined;
  notificationSettings: any = {
    course: {},
    test: {},
    order: {}
  };
  data() {
    return {
      user: undefined,
      userId: undefined
    };
  }

  mounted() {
    this.userId = this.$route.params.id;

    api.UsersApi.get(this.userId)
      .then(async res => {
        this.user = res.data;

        this.notificationSettings.course = await User.getStudentStartLearningSettings(
          this.userId!
        );
        this.notificationSettings.order = await User.getNewLearningRequestSettings(
          this.userId!
        );
        this.notificationSettings.test = await User.getStudentFinishLearningSettings(
          this.userId!
        );

        document.title += ` ${this.user.fullName}`;
        // const { data } = await notificationApi.User.getNotificationUserSettings(this.userId!)
      })
      .catch(() => {
        this.$bvToast.toast(
          this.$tc(this.$translate.UnableToRetrieveUserInformation),
          {
            variant: "danger",
            title: this.$tc(this.$translate.Error)
          }
        );
      });
  }
}
